module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/9200459659/point01-4a4fd02aa2ca508ba56aa83a9f563492.png";